var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "deep-table" }, [
    _vm.payload.rows.length > 10
      ? _c("div", { staticClass: "deep-table-toolbar" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filterText,
                expression: "filterText",
              },
            ],
            staticClass: "input is-small",
            attrs: { type: "search", placeholder: _vm.filterPlaceholder },
            domProps: { value: _vm.filterText },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.filterText = $event.target.value
              },
            },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "deep-table-scroll" }, [
      _c(
        "table",
        { staticClass: "table is-narrow is-striped is-hoverable is-fullwidth" },
        [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.payload.columns, function (column, index) {
                return _c(
                  "th",
                  {
                    key: column,
                    on: {
                      click: function ($event) {
                        return _vm.sortBy(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.headingFor(column)) +
                        "\n                        "
                    ),
                    _vm.sortIndex === index
                      ? _c("i", {
                          class: _vm.sortDescending
                            ? "fas fa-sort-down"
                            : "fas fa-sort-up",
                        })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.visibleRows, function (row) {
              return _c(
                "tr",
                { key: row.position },
                _vm._l(_vm.payload.columns, function (column, index) {
                  return _c(
                    "td",
                    {
                      key: column,
                      class: { "is-number": _vm.isNumber(row.cells[index]) },
                    },
                    [
                      _vm.linkFor(column, row.position)
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.linkFor(column, row.position),
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [_vm._v(_vm._s(_vm.display(row.cells[index])))]
                          )
                        : [_vm._v(_vm._s(_vm.display(row.cells[index])))],
                    ],
                    2
                  )
                }),
                0
              )
            }),
            0
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.footer
      ? _c("p", { staticClass: "deep-table-footer" }, [
          _vm._v(_vm._s(_vm.footer)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }